var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath23128(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.875,
    height: 40,
    viewBox: "0 0 41.875 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23128",
    "data-name": "Path 23128",
    d: "M99.389,140.085l5.111,10.344,11.438,1.663a2.5,2.5,0,0,1,1.387,4.265l-8.274,7.977,1.957,11.367a2.5,2.5,0,0,1-3.632,2.633l-10.229-5.3L86.92,178.4a2.5,2.5,0,0,1-3.633-2.632L85.244,164.4l-8.275-8.047a2.5,2.5,0,0,1,1.387-4.264l11.437-1.663L94.9,140.087a2.5,2.5,0,0,1,4.484,0",
    transform: "translate(-76.21 -138.695)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath23128);
export default __webpack_public_path__ + "static/media/Path 23128.bd6caf4e528f483ff4e44687c0daba36.svg";
export { ForwardRef as ReactComponent };